import { render, staticRenderFns } from "./PopUpMore18.vue?vue&type=template&id=a122af66&"
import script from "./PopUpMore18.vue?vue&type=script&lang=js&"
export * from "./PopUpMore18.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports